import store from '@/store';
import datalinesModification from '@/functions/datalinesModification';
import specialOperations from '@/functions/specialOperations';

const newCommand = function (regex, func) {
  return {
    regex: regex,
    func: func,
  };
};
const clearTerminalCMD = newCommand(
  RegExp('(^CLC$)|(^CLEAR$)', 'i'),
  async function () {
    store.commit('CLEAR_TERMINAL_SECTION');
  },
);

function getHelpSetPropWithValue(actionStr, property, axisStr){
  return `Apply an ${actionStr} on the selected dataline(s) in the ${axisStr}-axis.
  ${property}(element, value)
  Parameters:
    - element. Data line(s) to apply the offser on the ${axisStr}-axis:
    +++ All
    +++ Id of Processed Data Table
    +++ Array of id of Processed Data Table
    - value. Float value represeting the ${actionStr}`
}

const advancedHelpCMD = newCommand(
  /help\((.*)\)/i,
  async function (parent, reMatch) {
    if (reMatch[1] === 'flipx') {
      addToTerminal(
        `Flip the selected dataline(s) in the X-axis.
  flipx(element)
  Parameters:
    - element. Data line(s) to apply the flip in the X-axis:
      + All
      + Id of Processed Data Table
      + Array of id of Processed Data Table`,
        'INFO',
      );
    } else if (reMatch[1] === 'flipy') {
      addToTerminal(
        `Flip the selected dataline(s) in the Y-axis.
  flipy(element)
  Parameters:
    - element. Data line(s) to apply the flip in the Y-axis:
      + All
      + Id of Processed Data Table
      + Array of id of Processed Data Table`,
        'INFO',
      );
    } else if (reMatch[1] === 'offsetx') {
      addToTerminal(
        getHelpSetPropWithValue('offset', 'offsetx', 'X'),
        'INFO',
      );
    } else if (reMatch[1] === 'offsety') {
      addToTerminal(
        getHelpSetPropWithValue('offset', 'offsety', 'Y'),
        'INFO',
      );
    } else if (reMatch[1] === 'scalex') {
      addToTerminal(
        getHelpSetPropWithValue('scale', 'scalex', 'X'),
        'INFO',
      );
    } else if (reMatch[1] === 'scaley') {
      addToTerminal(
        getHelpSetPropWithValue('scale', 'scaley', 'Y'),
        'INFO',
      );
    } else {
      addToTerminal(`Command '${reMatch[1]}' not identified.`, 'ERROR');
    }
  },
);

const helpCMD = newCommand(/h(elp)?$/i, async function () {
  addToTerminal(
    `
    flipx:        Flip the selected dataline(s) in the X-axis.
    flipy:        Flip the selected dataline(s) in the Y-axis.
    cleanFlip:    Clear the flip changes applied on the current report.
    offsetx:      Apply an offset on the selected dataline(s) in the X-axis.
    offsety:      Apply an offset on the selected dataline(s) in the Y-axis.
    cleanOffset:  Clear the offset changes applied on the current report.
    scalex:       Apply a scale on the selected dataline(s) in the X-axis.
    scaley:       Apply a scale on the selected dataline(s) in the Y-axis.
    cleanScale:   Clear the scale changes applied on the current report.
    showChanges:  Lists the changes applied on the current report.

    For more information help(command)
`,
    'INFO',
  );
});

const fipxCMD = newCommand(/flipx\((.*)\)/i, async function (parent, reMatch) {
  return await datalinesModification.flipx(parent, reMatch[1]);
});
const fipyCMD = newCommand(/flipy\((.*)\)/i, async function (parent, reMatch) {
  return await datalinesModification.flipy(parent, reMatch[1]);
});
const offsetx = newCommand(
  /offsetx\((.*)\)/i,
  async function (parent, reMatch) {
    return datalinesModification.offsetx(parent, reMatch[1]);
  },
);
const offsety = newCommand(
  /offsety\((.*)\)/i,
  async function (parent, reMatch) {
    return datalinesModification.offsety(parent, reMatch[1]);
  },
);
const scalex = newCommand(
  /scalex\((.*)\)/i,
  async function (parent, reMatch) {
    return datalinesModification.scalex(parent, reMatch[1]);
  },
);
const scaley = newCommand(
  /scaley\((.*)\)/i,
  async function (parent, reMatch) {
    return datalinesModification.scaley(parent, reMatch[1]);
  },
);
const showChanges = newCommand(/showChanges(\(\))?/i, async function (parent) {
  return await datalinesModification.showChanges(parent);
});
const cleanOffset = newCommand(/cleanOffset(\(\))?/i, async function (parent) {
  return await datalinesModification.cleanOffset(parent);
});
const cleanScale = newCommand(/cleanScale(\(\))?/i, async function (parent) {
  return await datalinesModification.cleanScale(parent);
});
const cleanFlip = newCommand(/cleanFlip(\(\))?/i, async function (parent) {
  return await datalinesModification.cleanFlip(parent);
});


const createUnitTest = newCommand(
  /createUnitTest\((.*)\)/i,
  async function (parent, reMatch) {
    return specialOperations.createUnitTest(parent, reMatch[1]);
  },
);

const addToTerminal = function (text, type) {
  store.commit('ADD_MESSAGE_TERMINAL_SECTION', {
    type: type,
    text: text,
  });
};

const TerminalFunctions = {
  commands: [
    clearTerminalCMD,
    fipxCMD,
    fipyCMD,
    offsetx,
    offsety,
    scalex,
    scaley,
    showChanges,
    cleanOffset,
    cleanFlip,
    cleanScale,
    helpCMD,
    advancedHelpCMD,
    createUnitTest
  ],
  async executeCommand(parent, command) {
    try {
      store.commit('ADD_CMD_TERMINAL_SECTION', command);
      const matchCommand = this.commands.find((c) =>
        c.regex.test(command),
      );
      addToTerminal(command, 'COMMAND');
      if (typeof matchCommand !== 'undefined') {
        addToTerminal('Command recognized. Executing...', 'INFO');
        const reMatch = matchCommand.regex.exec(command);
        matchCommand.func(parent, reMatch, command);
      }
    } catch (e) {
      addToTerminal(
        'Error executing the command. Please try in a few minutes.',
        'ERROR',
      );
    }
  },
};

export default TerminalFunctions;